import React from 'react'
import Team from './Team';
import Dmmsg from './DMssg';
import Navbar from './navbar';
function TeamPage() {
    return (
        <team>
            <div id="#directors">
                {/* <Navbar /> */}
                <Dmmsg />
                <Team />
            </div>
        </team>
    )
}

export default TeamPage
